import { defineMessages } from 'react-intl';

import { EnforceBlock } from './types';

export const userSecurityMessages = defineMessages({
  title: {
    id: 'userSecurity.title',
    defaultMessage: 'Security',
  },
  statusTitle: {
    id: 'userSecurity.statusTitle',
    defaultMessage: 'Two-step verification (TOTP)',
  },
  statusIntro: {
    id: 'userSecurity.statusIntro',
    defaultMessage:
      'The state of this account\u2019s second factor, and the admin actions available on it.',
  },
  colProperty: {
    id: 'userSecurity.colProperty',
    defaultMessage: 'Property',
  },
  colValue: {
    id: 'userSecurity.colValue',
    defaultMessage: 'Value',
  },
  statusLabel: {
    id: 'userSecurity.statusLabel',
    defaultMessage: 'MFA',
  },
  statusEnabled: {
    id: 'userSecurity.statusEnabled',
    defaultMessage: 'Enabled',
  },
  statusDisabled: {
    id: 'userSecurity.statusDisabled',
    defaultMessage: 'Not set up',
  },
  setupAtLabel: {
    id: 'userSecurity.setupAtLabel',
    defaultMessage: 'Set up at',
  },
  recoveryCodesLeftLabel: {
    id: 'userSecurity.recoveryCodesLeftLabel',
    defaultMessage: 'Recovery codes left',
  },
  enforceLabel: {
    id: 'userSecurity.enforceLabel',
    defaultMessage: 'Enforce MFA',
  },
  enforceSuccess: {
    id: 'userSecurity.enforceSuccess',
    defaultMessage: 'MFA enforcement updated',
  },
  enforceError: {
    id: 'userSecurity.enforceError',
    defaultMessage: 'Failed to update MFA enforcement',
  },
  remove: {
    id: 'userSecurity.remove',
    defaultMessage: 'Remove MFA',
  },
  removeConfirmTitle: {
    id: 'userSecurity.removeConfirmTitle',
    defaultMessage: 'Remove MFA for this user?',
  },
  removeConfirmContent: {
    id: 'userSecurity.removeConfirmContent',
    defaultMessage:
      'Their authenticator app and recovery codes will stop working. If their password was set under the MFA minimum, they will have to reset it before signing in again. This cannot be undone.',
  },
  removeSuccess: {
    id: 'userSecurity.removeSuccess',
    defaultMessage: 'MFA removed',
  },
  removeError: {
    id: 'userSecurity.removeError',
    defaultMessage: 'Failed to remove MFA',
  },
  setup: {
    id: 'userSecurity.setup',
    defaultMessage: 'Set up MFA',
  },
  setupTitle: {
    id: 'userSecurity.setupTitle',
    defaultMessage: 'Set up MFA',
  },
  setupIntro: {
    id: 'userSecurity.setupIntro',
    defaultMessage:
      'Scan the QR code with an authenticator app (Google Authenticator, 1Password, etc.) or enter the secret manually, then confirm with the 6-digit code from the app.',
  },
  secretLabel: {
    id: 'userSecurity.secretLabel',
    defaultMessage: 'Manual secret',
  },
  codeLabel: {
    id: 'userSecurity.codeLabel',
    defaultMessage: 'Confirmation code',
  },
  codePlaceholder: {
    id: 'userSecurity.codePlaceholder',
    defaultMessage: '6-digit code',
  },
  confirm: {
    id: 'userSecurity.confirm',
    defaultMessage: 'Confirm',
  },
  setupError: {
    id: 'userSecurity.setupError',
    defaultMessage: 'Failed to start MFA setup',
  },
  confirmError: {
    id: 'userSecurity.confirmError',
    defaultMessage:
      'Failed to confirm MFA setup. Check the code and try again.',
  },
  recoveryCodesTitle: {
    id: 'userSecurity.recoveryCodesTitle',
    defaultMessage: 'Recovery codes',
  },
  recoveryCodesWarning: {
    id: 'userSecurity.recoveryCodesWarning',
    defaultMessage:
      'Save these single-use recovery codes now. They are shown only once and cannot be retrieved later.',
  },
  copyAll: {
    id: 'userSecurity.copyAll',
    defaultMessage: 'Copy all',
  },
  copySuccess: {
    id: 'userSecurity.copySuccess',
    defaultMessage: 'Recovery codes copied to clipboard',
  },
  copyError: {
    id: 'userSecurity.copyError',
    defaultMessage: 'Failed to copy to clipboard',
  },
  done: {
    id: 'userSecurity.done',
    defaultMessage: 'Done',
  },
  signInRequired: {
    id: 'mfa.signInRequired',
    defaultMessage:
      'Your authenticator is set up. Save these codes, then sign in again to finish.',
  },
  signInAgain: {
    id: 'userSecurity.signInAgain',
    defaultMessage: 'Sign in again',
  },
  loadError: {
    id: 'userSecurity.loadError',
    defaultMessage: 'Failed to load MFA status',
  },
  retry: {
    id: 'userSecurity.retry',
    defaultMessage: 'Retry',
  },
});

export const enforceBlockMessages = defineMessages<EnforceBlock>({
  noPermission: {
    id: 'userSecurity.enforceNoPermission',
    defaultMessage: 'You don’t have permission to change MFA enforcement.',
  },
  adminAccount: {
    id: 'userSecurity.enforceAdminAccount',
    defaultMessage:
      'This is an admin account. Changing its MFA enforcement requires the “Manage two-step verification of admin accounts” permission.',
  },
});
